import {useEffect,useRef,useState} from 'react'
import {createPortal} from 'react-dom'
import {NotificationCard} from '../NotificationCenter.jsx'

// Lives above the dialog, so closing a draft never aborts its save or hides failure.
export function useAlertFeedback(command,owner,select) {
 const [jobs,setJobs]=useState([]),current=useRef(owner),timers=useRef(new Set()),mounted=useRef(false),pending=useRef(new Set())
 current.current=owner
 useEffect(()=>{mounted.current=true;return()=>{mounted.current=false;for(const timer of timers.current)clearTimeout(timer)}},[])
 useEffect(()=>{setJobs([])},[owner])
 const dismiss=id=>setJobs(rows=>rows.filter(j=>j.id!==id))
 async function submit(body,id=crypto.randomUUID()) {
  if(pending.current.has(id))return
  pending.current.add(id)
  const startedOwner=owner,verb=body.action==='delete'?'delete':body.alert?.revision?'update':'create'
  const job={id,body,verb,status:'pending',owner}
  setJobs(rows=>[...rows.filter(j=>j.id!==id),job])
  const update=patch=>{if(mounted.current&&current.current===startedOwner)setJobs(rows=>rows.map(j=>j.id===id?{...j,...patch}:j))}
  try {
   const saved=await command(body)
   if(!mounted.current||current.current!==startedOwner)return
   if(body.action==='save')select(saved.id)
   update({status:'success'})
   const timer=setTimeout(()=>{timers.current.delete(timer);if(mounted.current)dismiss(id)},5000);timers.current.add(timer)
   return saved
  }catch(error){update({status:'error',error:error.message||'The server could not confirm this change.'})}
  finally{pending.current.delete(id)}
 }
 const feedback=typeof document==='undefined'?null:createPortal(<div className="fixed bottom-4 left-4 z-[9997] flex max-h-[50vh] flex-col gap-2 overflow-y-auto" aria-live="polite">{jobs.filter(j=>j.owner===owner).map(job=><div key={job.id} className="relative" role={job.status==='error'?'alert':'status'}>
  <NotificationCard showMeta={false} testId="price-alert-confirmation-toast" notification={{tone:job.status==='error'?'error':job.status==='success'?'success':'info',title:job.status==='pending'?(job.verb==='delete'?'Deleting alert…':'Saving alert…'):job.status==='error'?'Alert change not confirmed':`Alert ${ {create:'created',update:'updated',delete:'deleted'}[job.verb]}`,message:job.status==='error'?job.error:job.body.alert?.customName||job.body.alert?.symbol}} onDismiss={()=>dismiss(job.id)}/>
  {job.status==='error'&&<button className="mt-1 rounded border border-border bg-canvas px-3 py-1 text-xs text-ink" onClick={()=>void submit(job.body,job.id)}>Retry alert change</button>}
 </div>)}</div>,document.body)
 return {submit,feedback}
}
